import React from 'react';
import { Stack } from '@mui/material';
import { NoFormResponsesSVG } from '../../../../OverviewTab/Icons';
import { sharedClasses } from '../../../../../Components/CustomUIElements/sharedClasses';

export default function NoCustomFields() {
  return (
    <Stack sx={{ alignItems: 'center', rowGap: 2, padding: '60px 0px 80px 0px' }}>
      <NoFormResponsesSVG />
      <Stack sx={sharedClasses.emptyStateText}>No fields available</Stack>
    </Stack>
  );
}
